import React from 'react';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(customParseFormat);

interface DateTimeFormatterProps {
  date: Date | undefined;
  showTime?: boolean;
}

export const doesDateHaveTimeComponent = (input: string) => {
  return input.includes('T') || input.includes(' ');
};

export const getLocalisedDate = (input: string) => {
  if (doesDateHaveTimeComponent(input)) {
    return dayjs(input).format('L LT');
  } else {
    return dayjs(input).format('L');
  }
};

export const formatDate = (input: Date | dayjs.Dayjs, showTime?: boolean) => {
  const date = dayjs(input);
  let format = 'MMM DD';
  if (dayjs().year() !== date.year()) {
    format += ', YYYY';
  }
  if (showTime) {
    format += ', HH:mm';
  }
  return date.format(format);
};

export const formatTime = (date: Date | dayjs.Dayjs) => {
  const formattedTime = dayjs(date).format('HH:mm');
  return <span className='time'>{formattedTime}</span>;
};

export const FormattedDateTime = ({ date, showTime }: DateTimeFormatterProps) =>
  date ? (
    <>
      {formatDate(date)} {showTime ? formatTime(date) : null}
    </>
  ) : (
    <span>Date not defined</span>
  );

export default FormattedDateTime;
